const swiperBanner = new Swiper(".bannerSlider", {
    effect: "slide",
    speed: 1000,
    navigation: {
        nextEl: ".bannerslidernext",
        prevEl: ".bannersliderprev",
    },
});

const prodSlider = new Swiper(".prodCardSlider", {
    slidesPerView: 4,
    spaceBetween: 20,
    effect: "slide",
    speed: 800,
    breakpoints: {
        1025: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        769: {
            slidesPerView: 3.2,
            spaceBetween: 20,
        },

        576: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        300: {
            slidesPerView: 1.3,
            spaceBetween: 15,
        },
    },
});


const lastestPodCastSlider = new Swiper(".lastestPodCastSlider", {
    slidesPerView: 4,
    spaceBetween: 20,
    effect: "slide",
    speed: 800,
    breakpoints: {
        1025: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        576: {
            slidesPerView: 2.3,
            spaceBetween: 15,
        },
        300: {
            slidesPerView: 1.3,
            spaceBetween: 15,
        },
    },
    loop: true,
    autoplay: {
        delay: 50000,
        disableOnInteraction: false,
    },
});

{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".announcement_slider  .swiper-wrapper"
        );
        const slide = swiperWrapper.querySelector(".swiper-slide");

        if (slide) {
            for (let i = 0; i < 10; i++) {
                let clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            }
        }

        var swiper = new Swiper(".announcement_slider", {
            slidesPerView: "auto",
            spaceBetween: 30,
            loop: true,
            breakpoints: {
                150: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 20,
                },
                769: {
                    spaceBetween: 20,
                },
                1025: {
                    spaceBetween: 30,
                },
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 15000,
        });
    });
}